import { useEffect } from 'react';
import useMyInfo from '@api/hooks/auth/useMyInfo';
import { abProxyJWT, abVariations } from '@utils/abHelper';
import { fetchABExperimentData } from '@api/fetchers/experiments';
import useExperiments, { setExperimentVariation } from '@stores/experiments';
import { getIsFreeUser, getIsLoggedIn } from '@api/selectors/auth';
import { getExperimentVariation } from '@stores/selectors/experiments';
import cookies, { readCookie } from '@utils/cookies';
import validateAndSetSessionId, {
  DEVICE_ID_COOKIE_NAME
} from '@utils/session/validateAndSetSessionId';

const useDemoClassesExperiment = ({ goalUID }) => {
  const isFreeUser = useMyInfo(getIsFreeUser(goalUID));
  const isLoggedIn = useMyInfo(getIsLoggedIn);
  const accessToken = readCookie('accessToken');
  const experimentVariation = useExperiments(
    getExperimentVariation('demo_classes_component_web')
  );
  useEffect(() => {
    if (!accessToken || (accessToken && isLoggedIn && isFreeUser)) {
      validateAndSetSessionId();
      const deviceID = cookies.readCookie(DEVICE_ID_COOKIE_NAME);
      fetchABExperimentData('demo_classes_component_web', abProxyJWT, deviceID);
    } else if (isLoggedIn) {
      setExperimentVariation('demo_classes_component_web', null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accessToken, isFreeUser, isLoggedIn]);
  const isDemoClassExperiment =
    experimentVariation && experimentVariation === abVariations.TEST_1;

  return isDemoClassExperiment;
};

export default useDemoClassesExperiment;
